import { accordionAnatomy } from "@chakra-ui/anatomy";
import {
  Accordion,
  AccordionProps,
  createMultiStyleConfigHelpers,
} from "@chakra-ui/react";
import React from "react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(accordionAnatomy.keys);

const orderHistoryDetail = definePartsStyle({
  container: {
    border: "none",
    marginBottom: "8px",
    _last: {
      marginBottom: 0,
    },
  },
  icon: {
    display: "none",
  },
});

export const accordionTheme = defineMultiStyleConfig({
  variants: { "order-history-detail": orderHistoryDetail },
});

interface Props extends AccordionProps {}

// Now we can use the new `custom` variant
export default function OrderHistoryAccordion({ children, ...props }: Props) {
  return (
    <Accordion variant="order-history-detail" allowToggle={true} {...props}>
      {children}
    </Accordion>
  );
}
